module.exports = __webpack_public_path__ + "static/media/qualitas-provider.547e9a43.svg";